module.exports = __webpack_public_path__ + "static/media/collective_map.c6553787.png";